export default {
  Tag: {
    parts: ['container', 'label', 'closeButton'],
    baseStyle: {},
    sizes: {},
    variants: {
      neutral: {
        container: {
          bg: 'tertiary.base',
          variant: 'outline',
          color: 'text.base',
          borderColor: 'text.base',
          border: 'medium',
          p: '6px 18px',
          minW: 'min-content',
          justifyContent: 'center',
          borderRadius: '3px',
          fontWeight: 'semibold',
          boxShadow: 'none',
          h: 8,
        },
      },
      informative: {
        container: {
          bg: 'tertiary.light',
          variant: 'outline',
          color: 'text.base',
          borderColor: 'text.base',
          border: 'medium',
          p: '6px 18px',
          minW: 'min-content',
          justifyContent: 'center',
          borderRadius: '3px',
          fontWeight: 'semibold',
          boxShadow: 'none',
          h: 8,
        },
      },
      positive: {
        container: {
          bg: 'tertiary.base',
          variant: 'outline',
          color: 'text.base',
          borderColor: 'text.base',
          border: 'medium',
          p: '6px 18px',
          minW: 'min-content',
          justifyContent: 'center',
          borderRadius: '3px',
          fontWeight: 'semibold',
          boxShadow: 'none',
          h: 8,
        },
      },
      negative: {
        container: {
          bg: 'tertiary.base',
          variant: 'outline',
          color: 'text.base',
          borderColor: 'text.base',
          border: 'medium',
          p: '6px 18px',
          minW: 'min-content',
          justifyContent: 'center',
          borderRadius: '3px',
          fontWeight: 'semibold',
          boxShadow: 'none',
          h: 8,
        },
      },

      // TODO: move into newton
      tableStatus: {
        container: {
          bgColor: 'gray.50',
          px: '3',
          py: '2',
          fontSize: 'xs',
        },
      },
    },
    defaultProps: {},
  },
};
